/**
 * Tencent COS region allowlist for the frontend production-settings surfaces.
 *
 * Single source of truth mirroring the backend `TENCENT_COS_REGIONS`
 * (`apps/backend/src/lib/tencent-cos-credentials.ts`) + the DB CHECK in
 * `update_location_production_setting`. Keep in lockstep with those two.
 * `ap-singapore` is the only intl region (added 2026-05-24 for Bel Espirit's
 * intl 3PL account).
 *
 * Consumed by the per-location print-file region select AND the artwork
 * public-bucket region select in `LocationSettingsSection`, so the two never
 * drift. (`ProductionSettingsPage` / `PrintFileSelfHealSection` /
 * `SharedLocationsCard` still hand-roll their own inline copies of this list —
 * migrate them onto this const in a follow-up sweep.)
 */
export const TENCENT_COS_REGION_OPTIONS = [
  { value: 'ap-shanghai', label: 'ap-shanghai (Shanghai)' },
  { value: 'ap-guangzhou', label: 'ap-guangzhou (Guangzhou)' },
  { value: 'ap-beijing', label: 'ap-beijing (Beijing)' },
  { value: 'ap-shenzhen-fsi', label: 'ap-shenzhen-fsi (Shenzhen FSI)' },
  { value: 'ap-singapore', label: 'ap-singapore (Singapore, intl)' },
] as const;

export type TencentCosRegion = (typeof TENCENT_COS_REGION_OPTIONS)[number]['value'];

export const TENCENT_COS_REGIONS: readonly TencentCosRegion[] =
  TENCENT_COS_REGION_OPTIONS.map((o) => o.value);

export function isTencentCosRegion(value: string | null | undefined): value is TencentCosRegion {
  return value != null && (TENCENT_COS_REGIONS as readonly string[]).includes(value);
}
